import { message } from 'src/common/components/message';
import { i18n } from '@flowus/common/i18n';

export const loadingMessage = (key: string, title: string) => {
  message.loading({
    key,
    content: (
      <div className="flex items-center space-x-3">
        <div>{title}</div>
        <div onClick={() => message.closeMessage(key)} className="text-active_color animate-click">
          {i18n.t('components.loading_message.close_tip')}
        </div>
      </div>
    ),
  });
};
